// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./link.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._7yI1eKqpx{display:block;position:relative}._7yI1eKqpx._3dDTDQofx:after{background-color:rgba(0,0,0,0.2);content:'';height:calc(100% - 15px);left:0;position:absolute;top:10px;width:4px}@media screen and (-ms-high-contrast: active){._7yI1eKqpx._3dDTDQofx:after{height:0;width:0;display:none}}._7yI1eKqpx:not(._3dDTDQofx) ._7h7dFNYRx{display:none}._2190pWH3x{display:block;overflow:hidden}.cIV9yWZUx *{color:var(--primary-text)}._3S92pkF1x{color:var(--primary-text);background-color:rgba(0,0,0,0.08)}._3S92pkF1x:hover{background-color:rgba(0,0,0,0.1) !important}._3S92pkF1x *{-ms-high-contrast-adjust:none}._6uEYUkIhx{min-width:200px !important}._2GohwM8gx{z-index:5}._6NqXsKiMx{}._6NqXsKiMx>div:last-child{max-height:none}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"expanded": "_7yI1eKqpx",
	"active": "_3dDTDQofx",
	"expanded-list": "_7h7dFNYRx",
	"expandedList": "_7h7dFNYRx",
	"condensed": "_2190pWH3x",
	"menu-item": "cIV9yWZUx",
	"menuItem": "cIV9yWZUx",
	"menu-item-active": "_3S92pkF1x cIV9yWZUx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["highlighted"] + "",
	"menuItemActive": "_3S92pkF1x cIV9yWZUx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["highlighted"] + "",
	"menu-list": "_6uEYUkIhx",
	"menuList": "_6uEYUkIhx",
	"menu-backdrop": "_2GohwM8gx",
	"menuBackdrop": "_2GohwM8gx",
	"admin-menu-list": "_6NqXsKiMx _6uEYUkIhx",
	"adminMenuList": "_6NqXsKiMx _6uEYUkIhx"
};
module.exports = exports;
